module.exports = __webpack_public_path__ + "static/media/Forestbrook-Handbook.17b6429f.pdf";